(function(global) {
  'use strict';

  var AVAILABLE_SIZES = ['150x100', '250x150', '200x200', '250x250', '300x200', '305x305', '305x250', '400x305', '230x160', '200x80', '300x80', '400x80', '500x80', '600x80'];

  var CM_PER_FT = 30.48;

  var SIZE_LABELS = {
    '150x100': '150cm x 100cm / 5ft x 3.3ft',
    '230x160': '230cm x 160cm / 7.5ft x 5.2ft',
    '250x150': '250cm x 150cm / 8.2ft x 5ft',
    '200x200': '200cm x 200cm / 6.6ft x 6.6ft',
    '250x250': '250cm x 250cm / 8ft x 8ft',
    '300x200': '300cm x 200cm / 10ft x 6.5ft',
    '305x250': '305cm x 250cm / 10ft x 8ft',
    '305x305': '305cm x 305cm / 10ft x 10ft',
    '400x305': '400cm x 305cm / 13ft x 10ft',
    '200x80':  '200cm x 80cm / 6.5ft x 2.62ft',
    '300x80':  '300cm x 80cm / 10ft x 2.62ft',
    '400x80':  '400cm x 80cm / 13ft x 2.62ft',
    '500x80':  '500cm x 80cm / 16.4ft x 2.62ft',
    '600x80':  '600cm x 80cm / 19.7ft x 2.62ft'
  };

  function ftToCm(ft) {
    return Math.round(ft * CM_PER_FT);
  }

  function cmToFt(cm) {
    return cm / CM_PER_FT;
  }

  function getSizeLabel(size) {
    return SIZE_LABELS[size] || size;
  }

  function isRunnerSize(size) {
    var parts = size.split('x').map(Number);
    return parts.indexOf(80) !== -1;
  }

  function recommendSize(roomType, params) {
    var recommendation, explanation;
    switch (roomType) {
      case 'salon': {
        var sofaWidth = params.sofaWidth;
        if (sofaWidth < 160) {
          recommendation = '200x200';
          explanation = "Votre tapis dépassera votre canapé sur les côtés, pour un bel ancrage visuel.";
        } else if (sofaWidth < 200) {
          recommendation = '230x160';
          explanation = "Les pieds avant de votre canapé reposeront sur le tapis.";
        } else if (sofaWidth < 240) {
          recommendation = '300x200';
          explanation = "Assez grand pour accueillir l'ensemble de votre mobilier de salon.";
        } else {
          recommendation = '400x305';
          explanation = "Le format idéal pour un canapé d'angle ou une grande pièce à vivre.";
        }
        break;
      }
      case 'chambre': {
        var bedSize = params.bedSize;
        var bedMap = {
          simple: { size: '150x100', explanation: "En descente de lit, pour un réveil tout en douceur." },
          double: { size: '230x160', explanation: "Dépasse le lit sur les côtés pour un confort optimal." },
          queen:  { size: '300x200', explanation: "Vos pieds resteront au chaud tout autour du lit." },
          king:   { size: '400x305', explanation: "Le format qui accompagne parfaitement un lit King." }
        };
        recommendation = bedMap[bedSize].size;
        explanation    = bedMap[bedSize].explanation;
        break;
      }
      case 'couloir': {
        var length = params.length;
        if (length < 2.5) {
          recommendation = '200x80';
        } else if (length < 3.5) {
          recommendation = '300x80';
        } else if (length < 4.5) {
          recommendation = '400x80';
        } else if (length < 5.5) {
          recommendation = '500x80';
        } else {
          recommendation = '600x80';
        }
        explanation = "Un tapis de couloir fait 80 cm de large, pensé pour laisser du dégagement de chaque côté.";
        break;
      }
      case 'salle-a-manger': {
        var tableLength = params.tableLength;
        if (tableLength <= 140) {
          recommendation = '300x200';
          explanation = "Vos chaises resteront sur le tapis, même reculées.";
        } else if (tableLength <= 180) {
          recommendation = '305x250';
          explanation = "Assez grand pour que toutes les chaises restent sur le tapis, même reculées.";
        } else {
          recommendation = '400x305';
          explanation = "Le format qui accompagne les grandes tables familiales.";
        }
        break;
      }
      default:
        recommendation = '300x200';
        explanation = "Notre format le plus polyvalent.";
    }
    if (AVAILABLE_SIZES.indexOf(recommendation) === -1) {
      recommendation = findClosestAvailableSize(recommendation);
    }
    return { size: recommendation, explanation: explanation };
  }

  function findClosestAvailableSize(targetSize) {
    var parts = targetSize.split('x').map(Number);
    var targetArea = parts[0] * parts[1];
    var targetIsRunner = isRunnerSize(targetSize);
    var pool = AVAILABLE_SIZES.filter(function(size) {
      return isRunnerSize(size) === targetIsRunner;
    });
    var closest = pool[0];
    var closestDiff = Infinity;
    pool.forEach(function(size) {
      var p = size.split('x').map(Number);
      var diff = Math.abs((p[0] * p[1]) - targetArea);
      if (diff < closestDiff) { closestDiff = diff; closest = size; }
    });
    return closest;
  }

  function applyMeridieneOverride(result, sofaWidth) {
    var minSize = sofaWidth >= 220 ? '400x305' : '305x250';
    var resultParts = result.size.split('x').map(Number);
    var minParts = minSize.split('x').map(Number);
    if ((resultParts[0] * resultParts[1]) < (minParts[0] * minParts[1])) {
      return {
        size: minSize,
        explanation: minSize === '400x305'
          ? "Pour un canapé d'angle, ce format dépasse le canapé de tous les côtés."
          : "Pour une méridienne, ce format assure un ancrage visuel généreux."
      };
    }
    return result;
  }

  global.TigmeeCalc = {
    AVAILABLE_SIZES: AVAILABLE_SIZES,
    recommendSize: recommendSize,
    findClosestAvailableSize: findClosestAvailableSize,
    applyMeridieneOverride: applyMeridieneOverride,
    getSizeLabel: getSizeLabel,
    isRunnerSize: isRunnerSize,
    ftToCm: ftToCm,
    cmToFt: cmToFt,
    CM_PER_FT: CM_PER_FT
  };

})(window);
